import { PaymentMethod } from '@40seas/entities/payment-methods';
import { PaymentMethodType } from '@40seas/models';
import Stripe from 'stripe';
import { CardPaymentMethod } from '../card-payment-method.entity';

export async function cardPaymentMethodTypeHandler(stripePaymentMethod: Stripe.PaymentMethod): Promise<Partial<PaymentMethod>> {
    return {
        methodType: PaymentMethodType.Card,
        methodTypeFields: {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore - Fix TS FS-3199
            fingerPrint: stripePaymentMethod.card.fingerprint,
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore - Fix TS FS-3199
            brand: stripePaymentMethod.card.brand,
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore - Fix TS FS-3199
            expMonth: stripePaymentMethod.card.exp_month,
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore - Fix TS FS-3199
            expYear: stripePaymentMethod.card.exp_year,
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore - Fix TS FS-3199
            last4: stripePaymentMethod.card.last4,
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore - Fix TS FS-3199
            funding: stripePaymentMethod.card.funding,
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore - Fix TS FS-3199
            country: stripePaymentMethod.card.country,
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore - Fix TS FS-3199
            cardholderName: stripePaymentMethod.billing_details.name,
        } as CardPaymentMethod,
    };
}
